import { render, staticRenderFns } from "./TestAdd2.vue?vue&type=template&id=74e3ead6&"
import script from "./TestAdd2.vue?vue&type=script&lang=js&"
export * from "./TestAdd2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports